<template>
    <div>
        <v-row v-if="ownerType==='verein'" no-gutters align="center"
               class="white--text grey mt-5 rounded-tl rounded-tr">
            <v-col class="grow text-h6 font-weight-regular pl-4">Vereinskugeln ({{owner.name}})</v-col>
            <v-col class="shrink py-3 pr-4">
                <v-btn color="primary" @click="newKugel()">
                    <v-icon>mdi-plus</v-icon>Neue Kugel
                </v-btn>
            </v-col>
        </v-row>
        <kugel-liste :kugeln="kugeln" @reload="loadKugeln" @deleted="deleteKugel" @openEdit="editKugel"/>
        <div v-if="ownerType==='spieler'" class="text-right pt-3">
            <v-btn color="primary" @click="newKugel()">
                <v-icon>mdi-plus</v-icon>Neue Kugel
            </v-btn>
        </div>
        <kugel-edit :kugel="kugelTemp" @saved="updateList"/>
    </div>
</template>

<script>
import KugelEdit from "@/views/kugeln/kugelEdit";
import KugelListe from "@/views/kugeln/kugelListe";
import {Kugel} from "@/services/data/kugeln/kugel";
import FirebaseRead from "@/services/database/firebaseRead";
import RouterServices from "@/utilities/services/router/routerServices";
export default {
    name: "kugel-home",
    components: {KugelListe, KugelEdit},
    props: ['owner', 'ownerType'],
    data: () => ({
        kugelTemp: null,
        kugeln: [],
    }),
    created(){
        if ( this.owner ) this.loadKugeln()
    },
    methods: {
        async newKugel(){
            this.kugelTemp = new Kugel(null, this.owner, this.ownerType, await this.getBirthday())
            RouterServices.pushRouteQueryParameter(this.$router, this.$route, 'editKugel', 'true' )
        },
            async getBirthday(){
                let birthday = ''
                if ( this.ownerType === 'spieler' ) {
                    const spielerPrivat = await FirebaseRead.readSingleDoc(
                        'spieler/' + this.owner.id + '/private', this.owner.id
                    )
                    birthday = spielerPrivat.geburtsdatum
                }
                return birthday
            },
        async loadKugeln(){
            this.kugeln = await FirebaseRead.readDocListDouble(
                'kugeln',
                [
                    {field: 'ownerId', operator: '==', value: this.owner.id},
                    {field: 'ownerType', operator: '==', value: this.ownerType}
                ]
            )
            this.kugeln.sort((a, b) => a.nr > b.nr ? 1 : -1);
        },
        async editKugel(kugel){
            this.kugelTemp = new Kugel(kugel, this.owner, this.ownerType, await this.getBirthday())
            RouterServices.pushRouteQueryParameter(this.$router, this.$route, 'editKugel', 'true' )
        },
        deleteKugel(kugelId){
            const i = this.kugeln.findIndex(kugel => kugel.id === kugelId)
            this.kugeln.splice(i, 1)
        },
        updateList(item){
            const kugeln = JSON.parse(JSON.stringify(this.kugeln))
            const i = kugeln.findIndex(kugel => kugel.id === item.id)
            if ( i !== -1 ) {
                kugeln.splice(i, 1, item)
            } else {
                kugeln.push(item)
            }
            kugeln.sort((a, b) => b.tsCreated > a.tsCreated ? 1 : -1);
            this.kugeln = kugeln
            this.kugelTemp = null
        }
    },
    watch: {
        owner(){
            this.loadKugeln()
        }
    }
}
</script>

<style scoped>

</style>